import { render, staticRenderFns } from "./TakipAcVekaletEkleForm.vue?vue&type=template&id=64e13820&scoped=true"
import script from "./TakipAcVekaletEkleForm.vue?vue&type=script&lang=ts"
export * from "./TakipAcVekaletEkleForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e13820",
  null
  
)

export default component.exports